import {
  Component, TemplateRef, Input, QueryList, ViewChildren, SimpleChanges, Output,
  EventEmitter, ElementRef
} from '@angular/core';
import {ExceptionOption} from "../scroll-list/scroll-list";
import {global} from "../../environments/global";
declare var $:any;

/**
 * Generated class for the InfiniteScrollComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 *
 * 无限滚动插件,需定义item的类名为 scroll-item ,如果不想要 预定义的样式 请添加 simple 类
 *
 */
@Component({
  selector: 'infinite-scroll',
  templateUrl: 'infinite-scroll.html'
})
export class InfiniteScrollComponent {

  text: string;

  // @ViewChildren('Item') Item:QueryList<any>;
  @Input('scrollBox') scrollBox:ElementRef;


  @Input('scrollBody') scrollBody:TemplateRef<any>;
  @Input('data') data:Array<any>;
  @Input('totalCount') totalCount: number;
  @Input('is_loading') is_loading:boolean;
  @Input('maxPage') maxPage:number;
  @Input('pagesize') pagesize:number;
  @Input('page') page:number;
  @Input('expOpt') expOpt: ExceptionOption = {};

  @Output() onNextPage  = new EventEmitter();
  @Output() onErrConfirmed = new EventEmitter();
  @Output() onNodataConfirmed = new EventEmitter();



  realList;
  is_pre;
  min_page = 1;
  max_page = 1;

  constructor() {

  }
  ngOnInit(): void {
    this.expOpt = this.expOpt || {};
    this.expOpt.nodataText = this.expOpt.nodataText || global.nodataText;
    this.expOpt.errText = this.expOpt.errText || global.errText;
    this.expOpt.errBtnText = this.expOpt.errBtnText || global.errBtnText;
  }
  ngOnChanges(changes:SimpleChanges){
    if(changes['data'] ){

      if(this.data.length == 0){
        this.showNodata();
      }
      else {
        this.dismissNodata();
      }

      this.initRealList(this.max_page);
    }

  }
  ngAfterViewInit(){
  }

  initData(){
    this.max_page = 1;
    this.min_page = 1;
    this.is_pre = false;
    this.realList = [];
    this.dismissNodata();
  }

  updateView(){
    try{
      console.log(this.is_pre);
      if(this.is_pre){
        let container = $('.scroll-box');
        let scrollToDom = $('.scroll-box').find(".scroll-item:eq("+ this.pagesize +")");
        console.log(scrollToDom);
        console.log(container);
        container.scrollTop(scrollToDom.offset().top - container.offset().top + container.scrollTop() );
        this.is_pre = false;
      }
    }
    catch (e){
      console.log(e);
    }
  }



  initRealList(page){
    if(page > Math.ceil(this.totalCount/this.pagesize)){
      page = Math.ceil(this.totalCount/this.pagesize);
    }
    this.max_page = page;
    this.min_page = this.max_page > this.maxPage?(this.max_page - this.maxPage + 1):1;
    this.realList = this.data.slice((this.min_page - 1)*this.pagesize,this.max_page*this.pagesize);
  }

  onScroll(e){
    let el = e.target;

    if(!this.is_loading && el.scrollTop + el.clientHeight > el.scrollHeight - 10 ){
      if(this.max_page == this.page && this.page < Math.round(this.totalCount/this.pagesize)){
        this.max_page ++;
        this.onNextPage.emit(true);
      }
      else if(this.max_page < this.page && this.page <= Math.round(this.totalCount/this.pagesize)){
        this.initRealList(this.max_page + 1);
      }
    }
    else if(!this.is_loading && el.scrollTop < 1) {
      if(this.page > this.maxPage){
        if(this.max_page > this.maxPage){
          this.initRealList(this.max_page -1);
          this.is_pre = true;
        }
      }
    }
  }


  curException;
  ERROR_EXP :Symbol = <Symbol>Symbol();
  NODATA_EXP:Symbol = <Symbol>Symbol();
  public showErr() {
    this.curException = this.ERROR_EXP;
  }

  public expConfirmClicked() {
    this.onErrConfirmed.emit();
    this.curException = undefined;
    this.data = undefined;
  }

  public nodataConfirmClicked() {
    this.onNodataConfirmed.emit();
  }

  private showNodata() {
    this.curException = this.NODATA_EXP;
  }

  private dismissNodata() {
    this.curException = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/infinite-scroll/infinite-scroll.ts